import { render, staticRenderFns } from "./Banner.vue?vue&type=template&id=60023648&scoped=true&"
import script from "./Banner.vue?vue&type=script&lang=js&"
export * from "./Banner.vue?vue&type=script&lang=js&"
import style0 from "./Banner.vue?vue&type=style&index=0&id=60023648&prod&scoped=true&lang=css&"
import style1 from "./Banner.vue?vue&type=style&index=1&id=60023648&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60023648",
  null
  
)

export default component.exports